import CommonPopup from "..";
import { FindIdInfoIcon } from "../../../pages/Auth/FindId";
import CommonButton from "../../Button";

type Props = {
  isOpen: boolean;
  message: string;
  onClose?: () => void;
  onClick?: () => void;
  title?: string;
  unUseHorizonRule?: boolean;
  icon?: string;
  buttonText?: string;
  enableDimmedClose?: boolean;
};

export default function SimplePopup({
  isOpen,
  message,
  onClose,
  onClick,
  title,
  unUseHorizonRule,
  icon,
  buttonText,
  enableDimmedClose = true,
}: Props) {
  const getIcon = (iconName: string) => {
    switch (iconName) {
      case "notice":
        return <FindIdInfoIcon />;
      default:
        return null;
    }
  };

  return (
    <CommonPopup
      isOpen={isOpen}
      onClose={() => {
        if (enableDimmedClose) onClose?.();
      }}
      padding={0}
      title={title}
      unUseHorizonRule={unUseHorizonRule}
    >
      {icon ? (
        <div className="pb-5 flex flex-col gap-2.5 items-center px-5">
          {getIcon(icon)}
          <div className=" text-sm text-brand-neutral-60">{message}</div>
        </div>
      ) : (
        <div className="min-h-[110px] p-5 text-base font-medium flex items-center justify-center text-center whitespace-pre-line">
          {message}
        </div>
      )}
      <div className="w-full flex">
        <CommonButton
          variant="primary"
          className=" rounded-none w-full h-bottom-button"
          onClick={async () => {
            await onClick?.();
            await onClose?.();
          }}
          testId="simple-popup-confirm"
        >
          {buttonText ?? "확인"}
        </CommonButton>
      </div>
    </CommonPopup>
  );
}
